var Class = (function() {
	var subclass = function() {};

	var argumentNames = function(func) {
		var names = func.toString().match(/^[\s\(]*function[^(]*\(([^)]*)\)/)[1]
		  .replace(/\/\/.*?[\r\n]|\/\*(?:.|[\r\n])*?\*\//g, '')
		  .replace(/\s+/g, '').split(',');
		return names.length == 1 && !names[0] ? [] : names;
	};

	var create = function() {
		var parent = null, properties = $.makeArray(arguments);

		if ($.isFunction(properties[0]))
			parent = properties.shift();

		var klass = function() {
			this.initialize.apply(this, arguments);
		};

		$.extend(klass, Class.Methods);
		klass.superclass = parent;
		klass.subclasses = [];

		if (parent) {
			subclass.prototype = parent.prototype;
			klass.prototype = new subclass;
			parent.subclasses.push(klass);
		}

		for (var i = 0; i < properties.length; i++)
			klass.addMethods(properties[i]);

		if (!klass.prototype.initialize)
			klass.prototype.initialize = $.noop;

		klass.prototype.constructor = klass;
		return klass;
	};

	var keyfunc=(function (obj) {var keys = [];for (var key in obj) {keys.push(key);} return keys;});

	var addMethods = function(source) {
		if (typeof source == 'undefined') {
			return;
		}

		var ancestor   = this.superclass && this.superclass.prototype;
		var properties = keyfunc(source);

		if (!keyfunc({ toString: true }).length) {
			if (source.toString != Object.prototype.toString)
				properties.push("toString");
			if (source.valueOf != Object.prototype.valueOf)
				properties.push("valueOf");
		}

		for (var i = 0, length = properties.length; i < length; i++) {
			var property = properties[i], value = source[property];
			if (ancestor && $.isFunction(value) &&
					argumentNames(value)[0] == "$super") {
				var method = value;
				value = (function(p, m) {
					return function() {
						var that = this;
						return m.apply(this, $.merge([function() {
							return ancestor[p].apply(that, arguments);
						}], arguments));
					};
				})(property, method);

				value.valueOf = method.valueOf.bind(method);
				value.toString = method.toString.bind(method);
			}
			this.prototype[property] = value;
		}

		return this;
	};

	return {
		create: create,
		Methods: {
			addMethods: addMethods
		}
	};
})();

module.exports = Class;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.fs/chide/class.js